module.exports = __webpack_public_path__ + "img/gateway-logo.cd8175b8.jpg";